import { render, staticRenderFns } from "./PurL.vue?vue&type=template&id=338d9bb8"
import script from "./PurL.vue?vue&type=script&lang=js"
export * from "./PurL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports